import { User } from "./Car";

export interface NewsMenuType {
  date: string;
  title: string;
  description: string;
}

export interface Person {
  name: string;
  title?: string;
  imageUrl?: string;
  email?: string;
  phone?: string;
}

export interface IconItem {
  iconUrl?: "car" | "diamond" | "pricetag" | "box" ;
  title: string;
  description: string;
}

export interface HeaderConfig {
  headerText: string;
  headerImageUrl: string;
  subHeaderText?: string;
}

export interface Homepage {
  header:  HeaderConfig;
  iconMenu: IconItem[];
  newsMenu?: NewsMenuType[];
  team?: Person[];
}

export interface MapApiKeys {
  mapApiKey: string;
  mapId: string;
}



export interface CustomerContactData {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  customerID: number;
  name: string;
  companyName: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  streetAddress: string;
  postalCode: string;
  country: string;
  latitude?: string | null;
  longitude?: string | null;
  contactUsers: User[];
  facebookLink?: string | null;
  instagramLink?: string | null;
  xLink?: string | null;
  tikTokLink?: string | null;
}

export interface Configuration {
  primaryColor: string;
  logoImageId?: string;
  siteLocation?: string;
  secondaryColor?: string;
  footerDescription?: string;
  homepage: Homepage;
  // Written by the backend as the row's timestamp; the policy's default
  // effective date when the dealer has not set one.
  UpdatedAt?: string;
  tagSettings?: TagSettings;
  cookiePolicy?: CookiePolicy;
}

// The dealer's Tag Manager declaration. Only the container id matters here;
// the rest is edited in the portal and already folded into cookiePolicy.
export interface TagSettings {
  gtmContainerId: string;
}

// "necessary" is a service the dealer runs without asking. Consent Mode
// cannot gate a Tag Manager Custom HTML tag, so a container that loads one
// is described this way rather than implying a gate that is not there.
export type VendorCategory = "analytics" | "marketing" | "necessary";

export interface WebsiteCookie {
  name: string;
  duration: string;
  purpose: string;
}

export interface WebsiteVendor {
  id: string;
  name: string;
  provider: string;
  category: VendorCategory;
  cookies: WebsiteCookie[];
}

export interface PolicyBlock {
  id: string;
  title: string;
  text: string;
  kind: "fixed" | "vendor" | "extra";
  source: "default" | "custom";
}

// The values substituted for the {{placeholders}} in block text. An empty
// value means the backend had no default; the page backfills it.
export interface PolicyIdentity {
  companyName: string;
  domain: string;
  email: string;
  effectiveDate: string;
}

// The cookie policy resolved by the backend from the platform defaults and the
// dealer's edits. Block text keeps its placeholders; the page fills them.
export interface CookiePolicy {
  identity: PolicyIdentity;
  necessary: WebsiteCookie[];
  vendors: WebsiteVendor[];
  blocks: PolicyBlock[];
}



// Structural fallback only — no placeholder content, since this may render
// to real visitors when the fetched configuration is missing or malformed
export const defaultConfig: Configuration = {
  primaryColor: "#3F81F3",
  homepage: {
    header: {
      headerText: "",
      headerImageUrl: "",
      subHeaderText: "",
    },
    iconMenu: [],
    newsMenu: [],
    team: [],
  },
};
